import React from 'react'
import styled from '@emotion/styled'
import {
  FacebookShareButton,
  TwitterShareButton,
  LineShareButton,
  FacebookIcon,
  TwitterIcon,
  LineIcon
} from 'react-share'

const ICON_SIZE = 30

const COMMMUNE_TWITTER_ACCOUNT = 'commmunejp'

const ShareButtons = ({ url, title, ...props }) => {
  return (
    <Root {...props}>
      <TwitterShareButton
        url={url}
        title={title}
        via={
          COMMMUNE_TWITTER_ACCOUNT +
          ' ' /* NOTE: 見た目を調整するために半角スペースを追加してある */
        }
      >
        <TwitterIcon round size={ICON_SIZE} />
      </TwitterShareButton>
      <FacebookShareButton
        url={url}
        quote={title}
        style={{ marginLeft: '20px' }}
      >
        <FacebookIcon round size={ICON_SIZE} />
      </FacebookShareButton>
      <LineShareButton url={url} title={title} style={{ marginLeft: '20px' }}>
        <LineIcon round size={ICON_SIZE} />
      </LineShareButton>
    </Root>
  )
}

const Root = styled.div`
  display: flex;
  justify-content: center;
`

export default ShareButtons
